import { forwardRef } from "react";
import type { ImgHTMLAttributes } from "react";

type StaticImport = { src: string; width?: number; height?: number };

type NextImageProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "loading"> & {
  src: string | StaticImport;
  alt: string;
  width?: number | string;
  height?: number | string;
  fill?: boolean;
  priority?: boolean;
  loading?: "eager" | "lazy";
  quality?: number;
  placeholder?: "blur" | "empty";
  blurDataURL?: string;
  unoptimized?: boolean;
  sizes?: string;
};

const Image = forwardRef<HTMLImageElement, NextImageProps>(function Image(
  {
    src,
    alt,
    width,
    height,
    fill,
    priority,
    loading,
    quality: _q,
    placeholder: _p,
    blurDataURL: _b,
    unoptimized: _u,
    sizes: _s,
    style,
    ...rest
  },
  ref
) {
  const resolvedSrc = typeof src === "string" ? src : src.src;
  const fillStyle = fill
    ? { position: "absolute" as const, inset: 0, width: "100%", height: "100%", ...style }
    : style;
  const effectiveLoading = priority ? "eager" : loading;
  return (
    <img
      ref={ref}
      src={resolvedSrc}
      alt={alt}
      width={fill ? undefined : width}
      height={fill ? undefined : height}
      loading={effectiveLoading}
      style={fillStyle}
      {...rest}
    />
  );
});

export default Image;
